import React from "react";
import { useTranslation } from "react-i18next";
import { Dropdown } from "semantic-ui-react";

const FilterGame = ({ setSort }) => {
  const { t } = useTranslation();
  const i18n = (key) => t(`common.${key}`);

  const tagOptions = [
    {
      key: "A - Z",
      text: i18n("A - Z"),
      value: "A - Z",
    },
    {
      key: "totalDays",
      text: i18n("totalDays"),
      value: "totalDays",
    },
    {
      key: "7Days",
      text: i18n("7Days"),
      value: "7Days",
    },
    {
      key: "30Days",
      text: i18n("30Days"),
      value: "30Days",
    },
  ];
  return (
    <Dropdown
      className="!text-light-text"
      text={i18n("filter")}
      icon="filter"
      direction="left"
    >
      <Dropdown.Menu className="!w-[100px] !mr-[5px] !bg-second-color">
        {tagOptions.map((option) => (
          <Dropdown.Item
            onClick={() => setSort(option.value)}
            key={option.value}
            className="!text-light-gray"
            {...option}
          />
        ))}
      </Dropdown.Menu>
    </Dropdown>
  );
};

export default FilterGame;
